import { Alert, Divider } from '@ksyos/design-system';
import { useEffect } from 'react';
import { HeaderDivider } from '@frontend/components/elements/common';
import { TextAreaField } from '@frontend/components/fields';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';
import type { ValidationErrors } from '../../../../../utils/validation';
import type { ICustomControlData } from './customControlData';
import { RadioGroupField } from '../../../../fields/RadioGroup';

export function AdviesBijAfwijkendeBeoordelingAddEdit({
    customControlData: { adviesBijAfwijkendeBeoordeling, adviesBijAfwijkendeBeoordelingVraag },
    errors,
    handleChangeCustomControl,
}: Readonly<{
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (customControl: Partial<ICustomControlData>) => Promise<void>;
}>) {
    const {
        frontendSettings: { isTcohMkcFeatureEnabled },
    } = useFrontendSettings();

    if (isTcohMkcFeatureEnabled === false) {
        return null;
    }

    useEffect(() => {
        if (adviesBijAfwijkendeBeoordeling === 'Nee') {
            handleChangeCustomControl({ adviesBijAfwijkendeBeoordelingVraag: null });
        }
    }, [adviesBijAfwijkendeBeoordeling]);

    return (
        <>
            <Divider />
            <HeaderDivider text="Advies" />

            <Alert appearance="info">
                Let op: Voor een goed consult is het belangrijk dat je zoveel mogelijk informatie invult. De cardioloog
                krijgt zo een duidelijk beeld van de patiënt.
            </Alert>

            <RadioGroupField
                automation="adviesBijAfwijkendeBeoordeling"
                error={errors.get('customControlData.adviesBijAfwijkendeBeoordeling')}
                fieldKey="adviesBijAfwijkendeBeoordeling"
                hasErrors={errors.has('customControlData.adviesBijAfwijkendeBeoordeling')}
                label="Consultvraag indien afwijkend"
                options={['Ja', 'Nee']}
                value={adviesBijAfwijkendeBeoordeling ?? null}
            />

            {adviesBijAfwijkendeBeoordeling === 'Ja' && (
                <TextAreaField
                    error={errors.get('customControlData.adviesBijAfwijkendeBeoordelingVraag')}
                    fieldKey="adviesBijAfwijkendeBeoordelingVraag"
                    hasErrors={errors.has('customControlData.adviesBijAfwijkendeBeoordelingVraag')}
                    isRequired={true}
                    label="Vraag aan de specialist"
                    placeholder=""
                    value={adviesBijAfwijkendeBeoordelingVraag ?? null}
                />
            )}
        </>
    );
}
